import { InjectionToken } from '@angular/core';
import { RouteInfo } from './route-info.model';
import { Observable } from 'rxjs';

export const LayoutConfigToken = new InjectionToken<IRouteProvider>('LayoutConfigToken');

export interface IRouteProvider {
  get routes$(): Observable<RouteInfo[]>;
}
